import { render, staticRenderFns } from "./VocabularyBook.vue?vue&type=template&id=44fab684&"
import script from "./VocabularyBook.vue?vue&type=script&lang=js&"
export * from "./VocabularyBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports